module.exports = __webpack_public_path__ + "static/media/Primeape_gaussian2.f0e00427.png";